import * as apiGet from 'api/timeUnit/GetTimeUnitIdV1';
import * as apiPost from 'api/timeUnit/PostTimeUnitV1';
import * as apiPut from 'api/timeUnit/PutTimeUnitV1';
import * as apiTranslate from 'api/translation/PostTranslationV1';
import { LocalizedTranslation } from 'types/_general/LocalizedTranslation';

export type TranslationKeys =
	| 'nameSingularTranslations'
	| 'namePluralTranslations'
	| 'shortNameSingularTranslations'
	| 'shortNamePluralTranslations';

export default class TimeUnit {
	public id: string = '';
	public factorToSecond: number = 0;
	public nameSingularTranslations: LocalizedTranslation<string> = {};
	public namePluralTranslations: LocalizedTranslation<string> = {};
	public shortNameSingularTranslations: LocalizedTranslation<string> = {};
	public shortNamePluralTranslations: LocalizedTranslation<string> = {};

	public constructor(input?: apiGet.ResponseData) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiTranslation(fromCultureCode: string, toCultureCode: string): Promise<void> {
		const keys: TranslationKeys[] = [
			'nameSingularTranslations',
			'namePluralTranslations',
			'shortNameSingularTranslations',
			'shortNamePluralTranslations',
		];

		await Promise.all(
			keys.map(async (key) => {
				const response = await apiTranslate.callApi(
					this.mapToApiTranslate(key, fromCultureCode, toCultureCode)
				);
				response.hasValue() && this.mapFromApiTranslate(key, response.get(), toCultureCode);
			})
		);
	}

	public async callApiPut(): Promise<void> {
		await apiPut.callApi(this.id, this.mapToApiPut());
	}

	public async callApiPost(): Promise<void> {
		const response = await apiPost.callApi(this.mapToApiPost());
		response.hasValue() && this.mapFromApiPost(response.get());
	}

	private mapToApiTranslate(
		key: TranslationKeys,
		fromCultureCode: string,
		toCultureCode: string
	): apiTranslate.Request {
		return {
			fromCultureCode: fromCultureCode,
			toCultureCode: toCultureCode,
			text: this[key][fromCultureCode],
		};
	}

	private mapToApiPost(): apiPost.Request {
		return {
			factorToSecond: this.factorToSecond,
			nameSingularTranslations: this.nameSingularTranslations,
			namePluralTranslations: this.namePluralTranslations,
			shortNameSingularTranslations: this.shortNameSingularTranslations,
			shortNamePluralTranslations: this.shortNamePluralTranslations,
		};
	}

	private mapToApiPut(): apiPut.Request {
		return {
			factorToSecond: this.factorToSecond,
			nameSingularTranslations: this.nameSingularTranslations,
			namePluralTranslations: this.namePluralTranslations,
			shortNameSingularTranslations: this.shortNameSingularTranslations,
			shortNamePluralTranslations: this.shortNamePluralTranslations,
		};
	}

	private mapFromApi(input: apiGet.ResponseData) {
		this.id = input.id;
		this.factorToSecond = input.factorToSecond;
		this.nameSingularTranslations = input.nameSingularTranslations;
		this.namePluralTranslations = input.namePluralTranslations;
		this.shortNameSingularTranslations = input.shortNameSingularTranslations;
		this.shortNamePluralTranslations = input.shortNamePluralTranslations;
	}

	private mapFromApiPost(input: string) {
		this.id = input;
	}

	private mapFromApiTranslate(key: TranslationKeys, input: string, toCultureCode: string) {
		this[key][toCultureCode] = input;
	}
}
